<form [formGroup]="inputGroup">
    <ion-item [lines]="inline?'none':'inset'"
              [ngClass]="{'compact inline': inline, 'ion-invalid': !valid}">
        <ion-label *ngIf="!inline && hasValue && !errorShort && !errorDuplicate" position="stacked">
            {{ translationPrefix + '.input' | translate }}
        </ion-label>
        <ion-label *ngIf="hasValue && errorShort && !errorNotExisting" position="stacked" class="error">
            {{ translationPrefix + '.input-short' | translate }}
        </ion-label>
        <ion-label *ngIf="hasValue && errorDuplicate" position="stacked" class="error">
            {{ translationPrefix + '.input-duplicate' | translate }}
        </ion-label>
        <ion-label *ngIf="hasValue && errorNotExisting" position="stacked" class="error">
            {{ translationPrefix + '.input-not-existing' | translate }}
        </ion-label>
        <ion-label *ngIf="hasValue && errorNotAllowed" position="stacked" class="error">
            {{ translationPrefix + '.input-not-allowed' | translate }}
        </ion-label>
        <ion-input #input type="text" formControlName="inputControl" debounce=50 [size]="size"
                   [inputmode]="inputMode" [required]="required" [minlength]="minLength" [maxlength]="maxLength"
                   [type]="type" (ionChange)="lookup()"
                   placeholder="{{ translationPrefix + '.input' | translate }}">
        </ion-input>
        <ion-icon *ngIf="!inline && hasValue" slot="end" name="close" (click)="clearInput()">
        </ion-icon>
        <ion-icon *ngIf="valid && !inline" slot="end" name="send" (click)="send()">
        </ion-icon>
    </ion-item>
    <div class="possibilities" *ngIf="(numPossibilities>1) && (0==possibilities.length)">
        {{ numPossibilities }} {{  translationPrefix + '.possibilities' | translate }}
    </div>
    <div class="possibilities" *ngIf="0<possibilities.length"
         innerHTML="{{ numPossibilities }} {{  translationPrefix + '.chooser' | translate }}">
    </div>
    <ion-button size="small" fill="outline" *ngFor="let item of possibilities" (click)="choose(item)">
        {{item}}
    </ion-button>
</form>
